import { AuthService, NotificationService, ErrorService, LanguageService, UserService } from '@/services';
import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
    selector: 'app-mollie-redirect-catcher',
    templateUrl: './mollie-redirect-catcher.component.html',
    styleUrls: ['./mollie-redirect-catcher.component.scss'],
    standalone: false
})
export class MollieRedirectCatcherComponent implements OnInit {
  paymentCancel: boolean = false;

  voucherResponseCode: string = '';
  loading: boolean = false;
  loginPath: string;

  voucherActiveDate: number;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private languageService: LanguageService,
    private authService: AuthService,
    private userService: UserService,
    private notificationService: NotificationService,
    private errorService: ErrorService
  ) {}

  ngOnInit(): void {
    let tenantId = this.route.snapshot.queryParamMap.get('state')!;
    if (tenantId == 'cancel') {
      this.paymentCancel = true;
      this.loginPath = '/login';
      return;
    }
    let userId = this.route.snapshot.queryParamMap.get('usr')!;
    let firstLogin = this.route.snapshot.queryParamMap.get('user_first')!;
    let voucherCode = this.route.snapshot.queryParamMap.get('voucher')!;
    this.registerVoucher(tenantId, userId, firstLogin, voucherCode);
  }

  openDEPD() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigateByUrl(this.loginPath);
    });
  }

  registerVoucher(tenantId: string, userId: string, userFirst: string, voucherCode: string) {
    this.loading = true;
    setTimeout(() => {
      this.router.navigateByUrl('/');
    }, 5000);
    // this.userService.checkUserHasValidVoucher(userId).subscribe({
    // next: d => {
    //   this.loading = false;
    //   this.voucherResponseCode = d.code;
    //   switch (d.code) {
    //     case 'VOU_001':
    //       this.notificationService.success(
    //         this.languageService.translateWithCap(
    //           'vouchers.mollie-redirect.notifications.activated'
    //         )
    //       );
    //       var path = `/login?token=${d.data}`;
    //       if (userFirst == 'true') {
    //         path += '&first=true';
    //       }
    //       this.loginPath = path;

    //       break;
    //     case 'VOU_002':
    //       this.voucherActiveDate = d.data;

    //       this.loginPath = '/login';
    //       break;
    //     case 'VOU_010':
    //       this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    //         this.router.navigateByUrl(`/login`);
    //       });
    //       this.notificationService.error(
    //         this.languageService.translateWithCap(
    //           'vouchers.mollie-redirect.notifications.invalid'
    //         )
    //       );
    //       break;
    //     case 'VOU_011':
    //       // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    //       //   this.router.navigateByUrl(`/login`);
    //       // });
    //       this.notificationService.error(
    //         this.languageService.translateWithCap(
    //           'vouchers.mollie-redirect.notifications.already-activated'
    //         )
    //       );
    //       break;
    //   }
    // },
    // error: e => {
    //   this.errorService.onError(e);
    // }
    // });
  }
}
